<template>
  <v-select
    v-model="value_"
    :items="colleagues"
    item-value="id"
    item-text="firstName"
    :label="label"
    clearable
    dense
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      default: "Colleague",
    },
  },
  data: () => ({
    value_: "",
  }),
  computed: {
    ...mapGetters("config", ["getConfigByKey"]),
    colleagues() {
      let colleagues = this.getConfigByKey("colleagues") || [];
      colleagues = colleagues.map((colleague) => {
        // transformed
        return {
          ...colleague,
          firstName: colleague.first_name,
        };
      });
      return colleagues;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.value_ = value;
      },
      immediate: true,
    },
    value_(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    },
  },
};
</script>